import type { QuoteRequestStatus } from '@repo/api-contracts';

export interface QuoteStatusLabel {
  readonly label: string;
  readonly className: string;
}

/**
 * 운영자 화면 상태 이름 — 고객 화면 이름(견적 설계 §4-1)과 달리 운영 관점으로 적는다.
 * 처리할 건(REQUESTED·REVISION_REQUESTED)은 눈에 띄게, 끝난 건은 흐리게.
 */
export const QUOTE_STATUS_LABELS: Readonly<Record<QuoteRequestStatus, QuoteStatusLabel>> = {
  REQUESTED: { label: '검토 대기', className: 'text-amber-600' },
  ISSUED: { label: '발행됨', className: 'text-foreground' },
  REVISION_REQUESTED: { label: '수정 요청', className: 'text-amber-600' },
  ORDERED: { label: '주문됨', className: 'text-foreground' },
  DECLINED: { label: '고객 거절', className: 'text-muted-foreground' },
  REJECTED: { label: '반려', className: 'text-destructive' },
  CANCELED: { label: '요청 취소', className: 'text-muted-foreground' },
  EXPIRED: { label: '만료', className: 'text-muted-foreground' },
};
